/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Cost_Tokens_Multi_Request_NoteInputs */



/**
* | output |
* | --- |
* | "Summed across all requests in this turn. Each one re-sends the conversation, so this is higher than the context size above." |
*
* @param {Chat_Cost_Tokens_Multi_Request_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_cost_tokens_multi_request_note = /** @type {((inputs?: Chat_Cost_Tokens_Multi_Request_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Cost_Tokens_Multi_Request_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Summiert über alle Anfragen dieses Zuges. Jede sendet die Konversation erneut, daher liegt der Wert über der Kontextgröße oben.")
	return /** @type {LocalizedString} */ ("Summed across all requests in this turn. Each one re-sends the conversation, so this is higher than the context size above.")
});